import styled from 'styled-components';
import { theme } from '../layout/theme';
import { size } from '../layout/helpers';
import { H3 } from '../Heading';

export const SiteFooter = styled.footer`
  &.checkout-siteFooter {
    margin-top: auto;
  }
`;

export const Footer = styled.div`
  padding: ${size(5)} 0;
  background-color: ${theme.colors.bg.alt};
  color: ${theme.colors.text.onColor};

  ${theme.screens.Md} {
    padding: ${size(6)} 0;
  }
  &.checkout-footer {
    padding: 0;
    margin: 0;
  }
`;

export const CheckoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 80%;
  align-items: end;
  margin-top: 10px;

  ${theme.screens.LtMd} {
    width: 100%;
    align-items: center;
    margin-top: 0;
  }
  ${theme.screens.MdLtLg} {
    width: 100%;
    align-items: center;
    margin-top: 0;
  }
`;

export const FooterSection = styled.div`
  margin-top: ${size(5)};

  &:first-child {
    margin-top: 0;
  }

  &.checkout-footerSection {
    margin-top: 0;
  }

  ${theme.screens.Md} {
    margin-top: ${size(6)};

    &:first-child {
      margin-top: 0;
    }
  }

  &.separator-top {
    padding-top: ${size(5)};
    border-top: 1px solid ${theme.colors.border.onColor};

    ${theme.screens.Md} {
      padding-top: ${size(6)};
    }
  }
`;

export const CheckoutSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${size(5)} ${size(4)} ${size(2)} ${size(4)};

  ${theme.screens.LtMd} {
    flex-direction: column;
    align-items: center;
    padding: ${size(3)} ${size(4)} 0 ${size(4)};
  }
  ${theme.screens.MdLtLg} {
    flex-direction: column;
    align-items: center;
    padding: ${size(3)} ${size(4)} 0 ${size(4)};
  }
`;

export const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  &.link-groups {
    margin: ${size(-2)} 0;

    ${theme.screens.Md} {
      margin: ${size(-2)};
    }
  }
  &.checkout-links {
    display: flex;
    flex-direction: row;
    margin-right: 0;
    margin-bottom: ${size(-2)};
    width: 90%;
    margin-left: 0;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;

    ${theme.screens.LtMd} {
      width: 100%;
    }

    ${theme.screens.LtLg} {
      margin-top: ${size(1)};
      margin-right: 0;
      flex-direction: column;
      width: 100%;
      align-items: center;
    }
  }

  ${theme.screens.Md} {
    display: flex;
    flex-wrap: wrap;
    margin: ${size(-2)};
  }
`;

export const Item = styled.li`
  &.checkout-item {
    width: 100px;

    text-align: center;

    &:last-child {
      text-align: end;
      padding-right: 0;
    }

    ${theme.screens.LtMd} {
      width: 100%;
      padding: 0;
    }

    ${theme.screens.LtLg} {
      padding: ${size(1)} 0 ${size(1)} 0;
      margin-left: 0;
      width: 100%;
      text-align: center;
      &:last-child {
        text-align: center;
      }
    }
  }
  ${theme.screens.LtMd} {
    .spacing-ltmd & {
      margin-top: ${size(3)};

      &:first-child {
        margin-top: 0;
      }
    }
  }

  ${theme.screens.Md} {
    flex: 1 0 auto;
    width: 25%;
    max-width: 25%;
    padding: ${size(2)};
  }
`;

export const LinkGroup = styled.div``;

export const LinkGroupHeader = styled.div.attrs(() => ({
  role: 'button',
}))`
  display: flex;
  align-items: center;

  ${theme.screens.LtMd} {
    padding: ${size(2)} 0;
    cursor: pointer;
  }
`;

export const LinkGroupHeading = styled(H3)`
  flex: 1 1 auto;

  ${theme.screens.Md} {
    opacity: 0.6;
  }
`;

export const LinkGroupIcon = styled.div`
  flex-shrink: 0;
  padding-left: ${size(2)};

  ${theme.screens.Md} {
    display: none;
  }
`;

export const LinkGroupBody = styled.div`
  ${theme.screens.LtMd} {
    display: none;
    padding-bottom: ${size(2)};

    &.is-open {
      display: block;
    }
  }

  ${theme.screens.Md} {
    margin-top: ${size(4)};
  }
`;

export const LinkGroupItem = styled.div`
  & + & {
    margin-top: ${size(2)};
  }
`;

export const Link = styled.a`
  line-height: 1.3;

  &:hover {
    text-decoration: underline;
  }

  ${theme.screens.Md} {
    font-size: 1.125rem;
  }
`;

export const Bottom = styled.div`
  display: flex;

  ${theme.screens.LtMd} {
    flex-direction: column;
    align-items: center;
  }

  ${theme.screens.Md} {
    align-items: flex-end;
    justify-content: space-between;
  }
`;

export const BottomItem = styled.div`
  ${theme.screens.LtMd} {
    &.pos-right {
      margin-top: ${size(5)};
    }
  }

  ${theme.screens.Md} {
    &.pos-right {
      padding-left: ${size(2)};
    }
  }
`;

export const SocialList = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  padding: 0;

  &.checkout-sociallist {
    margin-top: ${size(5)};

    ${theme.screens.LtMd} {
      margin-top: ${size(3)};
    }

    ${theme.screens.MdLtLg} {
      margin-top: ${size(3)};
    }
  }
`;

export const SocialItem = styled.li`
  padding: ${size(1)};
  &.checkout-social-item {
    padding: ${size(1)} ${size(2)} ${size(1)} 0;

    &:last-child {
      padding-right: 0;
    }
  }
`;

export const IconLink = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const IconLinkIcon = styled.div`
  font-size: 1.25rem;
`;

export const IconLinkText = styled.div`
  font-size: 1rem;
  margin-left: ${size(2)};
  font-weight: ${theme.font.weight.medium};

  ${theme.screens.Md} {
    font-size: 1.125rem;
  }
`;

export const Store = styled.div`
  border-top: 1px solid ${theme.colors.border.main};
  padding-bottom: ${size(5)};
`;
